<form [formGroup]="form" (submit)="onSubmit()">
  <mat-form-field appearance="fill">
    <mat-label>Color</mat-label>
    <input matInput formControlName="color" (blur)="onSubmit()" />
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Intensity</mat-label>
    <input type="number" matInput formControlName="intensity" (blur)="onSubmit()" />
  </mat-form-field>
  <button style="display: none" type="submit"></button>
</form>
